// plugins/font-loader.js
import axios from 'axios';

export default async ({ app }) => {
    // const baseUrl = process.env.API_BASE_URL;
    // const token = process.env.TOKEN;
    const globalSettings = app.store.getters['global/globalSettings'];
    try {
        // const response = await axios({
        //     method: 'get',
        //     url: `${baseUrl}/settings/global_site_settings`,
        //     headers: {
        //         token: token
        //     }
        // });

        if (!globalSettings?.additional_settings) return;

        const { font_link: fontUrl, font_file: fontFile } = globalSettings?.additional_settings;

        if (fontFile) return;
        if (!fontUrl) return;

        const fontName = extractFontName(fontUrl);

        if (process.client) {
            const style = document.createElement('style');

            style.innerHTML = `
          @import url('${fontUrl}');
              :root {
                --body-font: '${fontName}', 'Inter', sans-serif;
                --habsev-font: '${fontName}', 'Inter', sans-serif;;
                --farmacie-font: '${fontName}', 'Onest', sans-serif;
              }
        `;

            document.head.appendChild(style);
        }
    } catch (error) {
        console.error('Error loading font:', error);
    }
};

function extractFontName(url) {
    const regex = /family=([^&]*)/;
    const match = url.match(regex);

    if (match) {
        const fonts = decodeURIComponent(match[1]);

        return fonts.split(':')[0];
    }

    return null;
}
